import React, { useState, useEffect, useRef } from 'react';
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios';
import swal from 'sweetalert';
import 'react-dropzone-uploader/dist/styles.css'
import Select, { components } from 'react-select';
import moment from 'moment';

import { Modal, Tabs, Tab } from 'react-bootstrap';
import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";
import PageLoader from "../common_component/PageLoader.js";

function BulkQrGeneartionSettings() {
    const [state, setState] = useState(2);
    const [operationType, setOperationType] = useState("Add");
    const [operationIndex, setOperationIndex] = useState("");
    const [qrSettings, setQrSettings] = useState([]);
    const [pageSize, setPageSize] = useState("A4");
    const pageSizeList = ["A4", "A3", "A2"];
    const qrTypeList = ["Product"];
    const qrForList = ["Basic Details (Pid,Product Name)", "Serial/Batch Details"];
    const [qrSettingsList, setqrSettingsList] = useState([]);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);
    const [qrSettingsModalShow, setQrSettingsModalShow] = useState(false);
    const [defaultModalShow, setDefaultModalShow] = useState(false);

    var page_name = "bulk-qr-generation-settings";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    async function getBulkQrGeneartionSettings() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-bulk-qr-generation-settings`, { method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "flag": true, "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.data.length > 0) {
            setqrSettingsList(body.data[0].qr_settings);
            setPageSize(body.data[0].page_size);
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getBulkQrGeneartionSettings();
            Promise.all([p1])
                .then(() => {
                    setState(1);
                    console.log("all apis done")
                })
                .catch((err) => {
                    setState(0)
                })
        }

    }, [user, visibility, read, write])

    const setAsDefault = (index) => {
        setOperationType("Set_default");
        setOperationIndex(index);
        setDefaultModalShow(true);
    }

    const editQrSettings = (obj, index) => {
        setOperationType("Edit");
        setOperationIndex(index);
        setQrSettings(obj.settings);
        setQrSettingsModalShow(true);
    }

    const addQrSettings = (obj) => {
        setOperationType("Add");
        setQrSettings([{ type: "Product", qrFor: ["Basic Details (Pid,Product Name)"] }]);
        setQrSettingsModalShow(true);
    }

    const SubmitQrSettings = (operation) => {
        const temp = [...qrSettingsList];
        if (operation === "Add") {
            temp.push({ settings_id: qrSettingsList.length + 1, settings: qrSettings, default: qrSettingsList.length === 0 ? true : false });
        }
        else if (operation === "Edit") {
            temp[operationIndex].settings = qrSettings;
        }
        else if (operation === "Set_default") {
            // Set all to false first
            temp.forEach((item, index) => {
                item.default = false;
            });
            // Then set the selected one to true
            temp[operationIndex].default = true;

            console.log(temp);
        }

        const object = { qr_settings: temp, page_size: pageSize, page_name: page_name, organization_id: organization_id };

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        setMainSubmitButtonState(true)
        axios.post(`${process.env.REACT_APP_SERVER_URL}/submit-bulk-qr-generation-settings`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success").then((value) => {
                    getBulkQrGeneartionSettings();
                    if (operationType === "Set_default") {
                        setDefaultModalShow(false);
                    }
                    else {
                        setQrSettingsModalShow(false);
                    }
                });
            }
            else {
                swal("Oops!", res.data.message.substring(0, 30), "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Bulk QR Generation Settings</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <button className='btn btn-success' onClick={(e) => { addQrSettings() }}>
                            <i className="las la-plus"></i>
                            Add Qr Settings
                        </button>
                    </div>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>
                                {
                                    qrSettingsList.length > 0 && (
                                        <div className="col-lg-12 mb-2">
                                            <div className="card card-flush h-lg-100 shadow-sm border border-dashed">
                                                <div className="card-body">
                                                    <div className="mb-4">
                                                        <label className="form-label fw-semibold text-muted">Select Page Size</label>
                                                        <Select
                                                            options={pageSizeList.map(x => ({ label: x, value: x }))}
                                                            value={{ value: pageSize, label: pageSize }}
                                                            onChange={(val) => setPageSize(val.value)}
                                                            classNamePrefix="react-select"
                                                        />
                                                    </div>
                                                    <div className="text-end">
                                                        <button
                                                            className="btn btn-primary fw-semibold"
                                                            onClick={(e) => SubmitQrSettings("Update_Ps")}
                                                            data-kt-indicator={mainSubmitButtonState ? "on" : "off"}
                                                            disabled={mainSubmitButtonState}
                                                        >
                                                            <i className="bi bi-arrow-repeat me-2" />
                                                            <span className="indicator-label">Update</span>
                                                            <span className="indicator-progress">Please wait...
                                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    )
                                }

                                < div className="row g-6 g-xl-9">
                                    {qrSettingsList.length == 0 ?
                                        <PageError message='No Data Available' />
                                        : qrSettingsList.map((obj, index) => {
                                            const setting = obj.settings[0];

                                            return (
                                                <div className="col-lg-6" key={obj.settings_id}>
                                                    <div className="card card-flush h-lg-100">
                                                        <div className="card-header mt-6">
                                                            <div className="card-title flex-column">
                                                                <h3 className="fw-bolder mb-1">Setting {index + 1}</h3>
                                                                {obj.default && (
                                                                    <span className="badge badge-light-success me-auto rounded">Default</span>
                                                                )}
                                                            </div>
                                                            <div className="card-toolbar">
                                                                {write && (
                                                                    <div className="dropdown">
                                                                        <button
                                                                            className="btn btn-sm btn-secondary rounded"
                                                                            type="button"
                                                                            id={`dropdownMenuButton${index}`}
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                        >
                                                                            <i className="fas fa-bars px-0"></i>
                                                                        </button>
                                                                        <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton${index}`}>
                                                                            <li>
                                                                                <a
                                                                                    onClick={() => editQrSettings(obj, index)}
                                                                                    className="dropdown-item cursor-pointer"
                                                                                >
                                                                                    Edit QR Settings
                                                                                </a>
                                                                            </li>
                                                                            {!obj.default &&
                                                                                <li>
                                                                                    <a
                                                                                        onClick={() => setAsDefault(index)}
                                                                                        className="dropdown-item cursor-pointer"
                                                                                    >
                                                                                        Set As Default
                                                                                    </a>
                                                                                </li>}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="card-body p-9">
                                                            <div className="fs-6 d-flex justify-content-between mb-4">
                                                                <div className="fw-bold">QR For</div>
                                                                <div className="text-end">
                                                                    {setting.qrFor.join(", ")}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </>
                            :
                            state == 2 ?
                                <PageLoader />
                                :
                                <PageError />
                    }
                </div>
            </div >

            <Modal show={defaultModalShow} onHide={() => setDefaultModalShow(false)} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Set as Default</Modal.Title>
                    <div
                        className="btn btn-sm btn-icon btn-active-color-primary"
                        onClick={() => setDefaultModalShow(false)}
                    >
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                                <g transform="translate(12,12) rotate(-45) translate(-12,-12) translate(4,4)" fill="#000000">
                                    <rect x="0" y="7" width="16" height="2" rx="1" />
                                    <rect opacity="0.5" transform="rotate(-270,8,8)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <div className="text-center">
                        <div className="mb-4">
                            <i className="bi bi-check2-circle fs-1 text-primary"></i>
                        </div>
                        <h4 className="mb-2">Do you want to set this as your default configuration?</h4>
                        <div className="text-muted">
                            This will be used automatically for future operations unless changed manually.
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="justify-content-end">
                    <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => setDefaultModalShow(false)}
                    >
                        Close
                    </button>

                    {write && (
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={(e) => SubmitQrSettings(operationType)}
                            data-kt-indicator={mainSubmitButtonState ? "on" : "off"}
                            disabled={mainSubmitButtonState}
                        >
                            <span className="indicator-label">Set as Default</span>
                            <span className="indicator-progress">
                                Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    )}
                </Modal.Footer>
            </Modal>

            <Modal show={qrSettingsModalShow} onHide={() => { setQrSettingsModalShow() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>{operationType} Qr Settings</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setQrSettingsModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        {qrSettingsList.length === 0 &&
                            <div className="col-md-4 mb-2">
                                <label className="form-label fw-semibold text-muted">Select Page Size</label>
                                <Select
                                    options={pageSizeList.map(x => ({ label: x, value: x }))}
                                    value={{ value: pageSize, label: pageSize }}
                                    onChange={(val) => setPageSize(val.value)}
                                    classNamePrefix="react-select"
                                />
                            </div>}
                        {qrSettings.map((setting, index) => (
                            <div key={index} className="row mb-3 align-items-center border border-primary rounded p-3">
                                {/* Dropdown: qrTypeList */}
                                <div className="col-md-4">
                                    <label className="form-label fw-bold">QR Type</label>
                                    <Select
                                        value={{ label: setting.type, value: setting.type }}
                                        onChange={(val) => {
                                            const updated = [...qrSettings];
                                            updated[index].type = val.value;
                                            setQrSettings(updated);
                                        }}
                                        options={qrTypeList.map(x => { return { label: x, value: x } })}
                                        isDisabled
                                    />
                                </div>

                                {/* Checkboxes: qrForList */}
                                <div className="col-md-8">
                                    <label className="form-label fw-bold">QR For</label>
                                    <div className="d-flex flex-wrap">
                                        {qrForList.map((label, i) => (
                                            <div key={i} className="form-check me-3">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`qrfor-${index}-${i}`}
                                                    disabled={i == 0}
                                                    checked={setting.qrFor.includes(label)}
                                                    onChange={(e) => {
                                                        const updated = [...qrSettings];
                                                        if (e.target.checked) {
                                                            updated[index].qrFor.push(label);
                                                        } else {
                                                            updated[index].qrFor = updated[index].qrFor.filter(x => x !== label);
                                                        }
                                                        setQrSettings(updated);
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor={`qrfor-${index}-${i}`}>
                                                    {label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setQrSettingsModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { SubmitQrSettings(operationType) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">{operationType == "Add" ? <>Save</> : <>Update</>}</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default BulkQrGeneartionSettings;